import { ColumnDef } from "@tanstack/react-table"
import React from "react"
import { ArrayColumnDefinition, ArrayDisplayType, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import { getValueFromObject } from "../../../../../../utils/object"
import { SelectOption } from "../../../../../types"

export default (columnDefinition: ArrayColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        /**
         * Using any instead of a union type here because of Typescript limitations with array functions and union types.
         * Issue with array functions that don't work with union types:
         * https://github.com/microsoft/TypeScript/issues/36390#issuecomment-852533093
         * 
         * Comment in the Typescript source code marking the .reduce union type test case failing as a known limitation:
         * https://github.com/microsoft/TypeScript/pull/31023/files#diff-7a118e355c5fce1fa4374a0e2b34732788f5695be1a6bf5b36bb71bcfa3b7fb9R28
         */
        /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
        const value = info.getValue() as any[]

        if (value) {
            const aggregationKey = columnDefinition.dataAttributes?.aggregationKey ?? ""
            const optionsKey = columnDefinition.dataAttributes?.optionsKey ?? ""
            const options = (info.table.options.meta?.additionalOptions ?? {})[optionsKey] ?? [] as SelectOption<string>[]
            const aggregatedArray  = value.reduce((aggregated: string[], next) => {
                if (typeof next === "string") {
                    return [...aggregated, next]
                } else {
                    const aggregatedValue = getValueFromObject(next, aggregationKey)

                    if (typeof aggregatedValue === "string") {
                        return [...aggregated, aggregatedValue]
                    } else {
                        return [...aggregated, ...aggregatedValue]
                    }
                }
            }, [])

            const mappedArray = aggregatedArray
                .filter(val => val)
                .map(val => {
                    const option = options.find(option => option.value === val)
                    return option ? option.label : val
                })
            const displayAs = columnDefinition.dataAttributes?.displayAs

            switch (displayAs) {
            case ArrayDisplayType.BADGE:
                return mappedArray.map(val => (
                    <div key={val} className="badge badge-primary badge-pill text-with-icon mr-1">
                        {val}
                    </div>
                ))
            case ArrayDisplayType.STRING:
            default:
                return mappedArray.join("\n")
            }
        }

        return columnDefinition.dataAttributes?.defaultValue || "-"
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/ArrayCellMapper.tsx